import FullCalendar from "@fullcalendar/react"
import { MutableRefObject } from "react"
import { GoToNextWrapper } from "./styles"
import { GrPrevious, GrNext } from "react-icons/gr"
import { useTranslation } from "react-i18next"
import { useRecoilState } from "recoil"
import { NewCalenderPageCount } from "@store/index"

interface IProps {
	calendarRef: MutableRefObject<FullCalendar | null>
}
export default function GoToNext({ calendarRef }: IProps) {
	const [pageCount, setPageCount] = useRecoilState(NewCalenderPageCount)
	const { i18n } = useTranslation()
	const isRTL = i18n.language === 'ar'

	const goToNext = () => {
		const calendarApi = calendarRef.current?.getApi()
		if (calendarApi) {
			calendarApi.next() // Navigate to the next period
			setPageCount(pageCount + 1)
		}
	}
	return (
		<GoToNextWrapper>
			<button onClick={goToNext}>
				{isRTL ? <GrPrevious /> : <GrNext />}
			</button>
		</GoToNextWrapper>
	)
}
